import {useEffect, useState} from "react";
import Login from "./Login";
import OtpForm from "./OtpForm";
import {Toaster} from "react-hot-toast";
import {useDispatch} from "react-redux";
import {resetToken} from "../../redux/actions/TokneAction";


export default function MainLoginPage() {
    const[goToPage, setGoToPage] = useState("login")
    const[transactionList, setTransactionList] = useState("")
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(resetToken())
    }, [])


    return (
        <div  style={{minHeight: "62.5vh"}}>
            <Toaster />
            {
                goToPage == "login" ?
                 <Login setGoToPage={setGoToPage}/> :
                <OtpForm setGoToPage={setGoToPage} setTransactionList={setTransactionList}/>
            }
        </div>
    );


}